module.exports = __webpack_public_path__ + "ecce855d1b3099e4b7d882b171ea472a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/target_2021_chart.png
// module id = 1741
// module chunks = 0